export default __webpack_public_path__ + "static/media/spinner-of-dots.c13a9925.svg";